// extracted by mini-css-extract-plugin
export default {"btns":"Login_btns__MsXOa","form":"Login_form__dHB6R","label":"Login_label__3MMmo","checkbox":"Login_checkbox__GAJr9"};